import React from 'react';
import { images, process } from '../data/site';
import { SectionHeading } from './SectionHeading';
export function Process() {
  return <section id="process" className="bg-steel-50 py-20 lg:py-28" data-id="element-151" data-mp="1uc23xoif24rg">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-20 lg:px-10" data-id="element-152" data-mp="1yeysrwyjux3u">
        <div className="relative" data-id="element-153" data-mp="23drtspwngvn4">
          <img src={images.weldBead} alt="Close-up of a stacked-dime fillet weld on structural steel" loading="lazy" className="aspect-[4/5] w-full border border-steel-200 object-cover" data-id="element-154" data-mp="23bxh1yvj89u4" />
          <div className="absolute -bottom-6 -right-4 max-w-[240px] bg-steel-950 p-6 sm:right-6" data-id="element-155" data-mp="1fno29gwqkmch">
            <div className="font-display text-3xl font-bold uppercase leading-none text-brand-light" data-id="element-156" data-mp="1kgh682kdrqni">
              No shortcuts
            </div>
            <p className="mt-3 text-sm leading-relaxed text-steel-300" data-id="element-157" data-mp="my7dct8brnl0">
              Full penetration where it matters, ground smooth where it shows.
            </p>
          </div>
        </div>

        <div data-id="element-158" data-mp="19n260z65bed8">
          <SectionHeading eyebrow="How It Works" tone="light" title={<>
                Four steps,
                <br data-id="element-160" data-mp="10rcoj17tj454" />
                zero runaround
              </>} description="You get a straight answer, a firm price, and a welder who shows up when he says he will." data-id="element-159" data-mp="15jm901q5zc00" />

          <ol className="mt-12 space-y-px border border-steel-200 bg-steel-200" data-id="element-161" data-mp="qw18mfkobqvs">
            {process.map(item => <li key={item.step} className="flex gap-6 bg-white p-6 lg:p-7" data-id="element-162" data-mp="lxzpjun8zrkb">
                <span className="font-display text-2xl font-bold leading-none text-brand" data-id="element-163" data-mp="hubh79qskry0">
                  {item.step}
                </span>
                <div data-id="element-164" data-mp="2c7t0ulo2t4nr">
                  <h3 className="font-display text-lg font-semibold uppercase tracking-tight text-steel-950" data-id="element-165" data-mp="2c71bvtozi56g">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-steel-500" data-id="element-166" data-mp="2qduwp99dzg5z">{item.body}</p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}